<script>
import AccountInformation from '@components/safehaven-account/account-settings/account-settings.vue'
import MyProfile from '@components/safehaven-account/my-profile/my-profile.vue'
import SecuritySettings from '@components/safehaven-account/security-settings/security-settings.vue'
import ProfilePicture from '@components/safehaven-account/profile-picture/profile-picture.vue'

export default {
  components: {
    AccountInformation,
    MyProfile,
    SecuritySettings,
    ProfilePicture,
  },
  data() {
    return {
      activeTab: null,
      showConnectedHealth: false,
    }
  },
  mounted() {
    this.activeTab = this.$route.params.tabId || null
  },
  methods: {
    updateData() {
      setTimeout(function () {
        document.getElementById('updateImperialUnitButton').click()
      }, 1000)
    },
    updateDataCaring() {
      setTimeout(function () {
        document.getElementById('updateImperialUnitButtonCaring').click()
      }, 1000)
    },
    setValue(val) {
      this.showConnectedHealth = val
    },
    activeSecuritySettings() {
      this.activeTab = 2
    },
  },

  page: {
    title: 'Profile',
    meta: [{ name: 'description', content: 'The Profile page.' }],
  },
}
</script>

<template>
  <v-container>
    <v-row :class="$style.sectionBackground">
      <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" md="1"></v-col>
      <v-col cols="12" :md="$vuetify.breakpoint.lgAndUp ? '11' : '12'">
        <v-tabs
          v-model="activeTab"
          next-icon="mdi-arrow-right-bold-circle"
          prev-icon="mdi-arrow-left-bold-circle"
          show-arrows
          center-active
          background-color="transparent"
          :class="[
            $style.tabClss,
            $vuetify.breakpoint.smAndUp ? 'mt-6' : 'mt-0',
          ]"
          color="rgba(0, 0, 0, 0.87)"
        >
          <v-tab key="1"> Account Information </v-tab>
          <v-tab key="2" @click="updateData"> My Profile </v-tab>
          <v-tab key="3"> Security Settings </v-tab>
          <v-tab-item>
            <v-row>
              <v-col cols="12" :md="$vuetify.breakpoint.lgAndUp ? '7' : '12'">
                <AccountInformation
                  @show-connected="setValue"
                  @goto-security-settings="activeSecuritySettings"
                ></AccountInformation>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row
              :class="
                $vuetify.breakpoint.mdAndDown ? $style.changePosition : ''
              "
            >
              <v-col
                :class="$vuetify.breakpoint.mdAndDown ? $style.col : ''"
                cols="12"
                :md="$vuetify.breakpoint.lgAndUp ? '7' : '12'"
              >
                <MyProfile></MyProfile>
              </v-col>
              <v-col
                :class="$vuetify.breakpoint.mdAndDown ? $style.colProfile : ''"
                cols="12"
                xl="3"
                :md="$vuetify.breakpoint.lgAndUp ? '5' : '12'"
              >
                <ProfilePicture></ProfilePicture>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-col cols="12" :md="$vuetify.breakpoint.lgAndUp ? '7' : '12'">
              <SecuritySettings></SecuritySettings>
            </v-col>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.validation {
  margin-top: 3px;
  margin-bottom: 3px;
  font-size: small;
  font-weight: bold;
  color: #b94a48;
  text-align: left;
}
.tabClss {
  background-color: transparent;
}
.sectionBackground {
  background-color: transparent;
}
.changePosition {
  flex-direction: column-reverse;
}
.col {
  padding-top: 0 !important;
}
.colProfile {
  padding-bottom: 0 !important;
}
</style>

<style scoped>
.v-tab {
  min-width: inherit !important;
  max-width: inherit !important;
  padding: 0;
  margin-right: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-transform: capitalize;
  letter-spacing: 0.15px;
}
/deep/ .v-slide-group__next--disabled {
  display: none !important;
}
/deep/ .v-slide-group__prev--disabled {
  display: none !important;
}
/deep/ .theme--light.v-icon {
  color: #0476d9 !important;
}
/deep/ .theme--light.v-tabs-items {
  background-color: transparent !important;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #0476d9 !important;
}

.v-tab--active {
  font-weight: 600 !important;
}
/deep/ .v-tabs-slider-wrapper {
  bottom: 8px !important;
}

/deep/ .theme--light.v-tabs .v-tab--active::before,
.theme--light.v-tabs .v-tab--active:hover::before,
.theme--light.v-tabs .v-tab:focus::before {
  opacity: 0;
}
/deep/ .theme--light.v-tabs .v-tab:hover::before {
  opacity: 0;
}
/deep/ .v-ripple__container {
  display: none !important;
}

@media screen and (max-width: 959px) {
  /deep/ .v-tabs-bar {
    padding: 0 12px;
  }
}
</style>
